
enum GSMProblemAction {
    CHANGE_CHECK_LOCATION_IN_HOUSE,
    IGNORE_AND_KEEP_CHECK_IN_CABINET,
    CANCEL_CHECK
}

export default GSMProblemAction;